import { Outlet, Navigate, useLocation } from 'react-router';
import { useAuth } from '@/features/auth/hooks';
import { LoadingScreen } from '@/components/shared/loading-screen';
import { Brand } from '@/components/shared/brand';
import { ThemeToggle } from '@/components/shared/theme-toggle';

export function AuthLayout() {
  const { status } = useAuth();
  const location = useLocation();
  if (status === 'loading') return <LoadingScreen />;
  if (status === 'authenticated') {
    const returnTo = new URLSearchParams(location.search).get('returnTo') ?? '/dashboard';
    return <Navigate to={returnTo} replace />;
  }
  return (
    <div className="flex min-h-dvh flex-col bg-background">
      <header className="mx-auto flex h-16 w-full max-w-content items-center justify-between px-4 sm:px-6 lg:h-18 lg:px-8">
        <Brand />
        <ThemeToggle />
      </header>
      <main className="flex flex-1 items-center justify-center px-4 py-12">
        <div className="w-full max-w-md rounded-xl border bg-card p-5 sm:p-8">
          <Outlet />
        </div>
      </main>
      <footer className="px-4 pb-6 text-center text-xs text-muted-foreground">
        Play with virtual coins. Make every prediction count.
      </footer>
    </div>
  );
}
